import React from "react";
import "../css/Workout.css";

const Workout2 = () => {
  return (
    <div className="workout2">

      {/* ---------------- HERO ---------------- */}
      <section className="workout2-hero">
        <img
          src="https://images.unsplash.com/photo-1584466977773-e625c37cdd50?auto=format&fit=crop&w=1500&q=80"
          alt="Workout Hero"
        />
        <div className="workout2-hero-text">
          <h1>THE FLEXOR TRAINING SYSTEM</h1>
          <p>Structured. Intelligent. Results-driven.</p>
        </div>
      </section>


      {/* ---------------- SECTION 1 — TRAINING CATEGORIES ---------------- */}
      <section className="workout2-categories">
        <h2>Training Paths</h2>

        <div className="categories-grid">

          <div className="cat-card">
            <div
              className="cat-img"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1521804906057-1df8fdb718b7?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            ></div>
            <h3>Strength Foundation</h3>
            <p>
              A progressive system designed to build core strength,
              joint stability, and structured form mastery.
            </p>
          </div>

          <div className="cat-card">
            <div
              className="cat-img"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1518310383802-640c2de311b2?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            ></div>
            <h3>Conditioning</h3>
            <p>
              High-intensity sessions designed to improve cardiovascular
              output, speed, and explosive endurance.
            </p>
          </div>

          <div className="cat-card">
            <div
              className="cat-img"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1540580015362-b650926ff6d7?q=80&w=689&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            ></div>
            <h3>Mobility & Control</h3>
            <p>
              Targeted sessions focused on posture, flexibility, and
              neuromuscular control for long-term durability.
            </p>
          </div>

        </div>
      </section>


      {/* ---------------- SECTION 2 — WEEKLY WORKOUT SCHEDULE ---------------- */}
      <section className="workout2-weekly">
        <h2>Weekly FLEXOR Structure</h2>

        <div className="workout-table-wrapper">
          <table className="workout-table">
            <thead>
              <tr>
                <th>Day</th>
                <th>Focus</th>
                <th>Main Exercises</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Monday</td>
                <td>Strength — Push</td>
                <td>
                  Bench Press, Dumbbell Shoulder Press, Weighted Dips,
                  Triceps Extensions
                </td>
              </tr>

              <tr>
                <td>Tuesday</td>
                <td>Mobility + Core</td>
                <td>
                  Hip Openers, Controlled Articulation Drills,
                  Planks, Dead Bug Variations
                </td>
              </tr>

              <tr>
                <td>Wednesday</td>
                <td>Strength — Pull</td>
                <td>
                  Deadlifts, Pull-Ups, Barbell Rows,
                  Face Pulls
                </td>
              </tr>

              <tr>
                <td>Thursday</td>
                <td>Conditioning</td>
                <td>
                  Sled Push, Assault Bike Intervals,
                  Kettlebell Swings
                </td>
              </tr>

              <tr>
                <td>Friday</td>
                <td>Strength — Legs</td>
                <td>
                  Squats, Lunges, RDLs,
                  Calf Raises
                </td>
              </tr>

              <tr>
                <td>Saturday</td>
                <td>Active Recovery</td>
                <td>
                  Light Mobility Flow, Walking, Stretch Reset
                </td>
              </tr>

              <tr>
                <td>Sunday</td>
                <td>Rest</td>
                <td>Full recovery + hydration</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>


      {/* ---------------- SECTION 3 — MUSCLE GROUP GRID ---------------- */}
      <section className="workout2-muscles">
        <h2>Muscle Group Breakdown</h2>

        <div className="muscle-grid">
          <div className="muscle-card">
            <h3>Chest</h3>
            <p>Bench Press · Incline DB Press · Fly Variations</p>
          </div>
          <div className="muscle-card">
            <h3>Back</h3>
            <p>Deadlifts · Pull-Ups · Lat Pulldowns</p>
          </div>
          <div className="muscle-card">
            <h3>Legs</h3>
            <p>Squats · Lunges · Leg Press · RDLs</p>
          </div>
          <div className="muscle-card">
            <h3>Shoulders</h3>
            <p>Overhead Press · Lateral Raises · Rear Delts</p>
          </div>
          <div className="muscle-card">
            <h3>Arms</h3>
            <p>Bicep Curls · Tricep Extensions · Cable Work</p>
          </div>
          <div className="muscle-card">
            <h3>Core</h3>
            <p>Planks · Rotational Drills · Stability Work</p>
          </div>
        </div>
      </section>


      {/* ---------------- SECTION 4 — EQUIPMENT TECHNIQUE ---------------- */}
      <section className="workout2-technique">
        <h2>Master Your Technique</h2>

        <div className="technique-grid">
          <div className="cat-card">
            <div
              className="cat-img"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1646492169621-d8da8016354a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            ></div>
            <h3>Barbell Mechanics</h3>
            <p>
              Learn proper bar paths, joint stacking,
              and tension control for maximal strength.
            </p>
          </div>

          <div className="cat-card">
            <div
              className="cat-img"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1600026453346-a44501602a02?q=80&w=685&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            ></div>
            <h3>Kettlebell Flow</h3>
            <p>
              Develop fluidity, control, and power through
              dynamic full-body sequences.
            </p>
          </div>

          <div className="cat-card">
            <div
              className="cat-img"
              style={{
                backgroundImage:
                  "url('https://images.unsplash.com/photo-1576491742123-735882d4ca7e?q=80&w=1172&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
              }}
            ></div>
            <h3>Mobility Tools</h3>
            <p>
              Increase range of motion and eliminate
              mechanical restrictions.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Workout2;
